export function getImageSrc () {
    let src = 'desktop'
    if (window.innerWidth < 840) src = 'mobile'
    else if (window.innerWidth < 1320) src = 'tablet'
    if (devicePixelRatio > 1) src += '-retina'

    return src;
}